module.exports = __webpack_public_path__ + "images/embed/table_bg.jpg";